import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { imgURL } from '../../Config';
import { getEventSchedule, getEventStatus } from '../../../Utils/eventSchedule';

const STATUS_LABELS = { upcoming: 'Upcoming', ongoing: 'Ongoing', past: 'Past event', unscheduled: 'Schedule to be confirmed' };

const EventCard = ({ event, lookupData = [], schedule = getEventSchedule(event), status = getEventStatus(schedule) }) => {
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [event.banner]);
  const banner = typeof event.banner === 'string' ? event.banner.trim() : '';
  const imageUrl = /^https?:\/\//i.test(banner)
    ? banner
    : String(imgURL || '').replace(/\/+$/, '') + '/' + (banner.startsWith('event_banners/') ? banner : 'event_banners/' + banner);
  const { start, end, hasStartTime, hasEndTime } = schedule;
  const dateLabel = start
    ? start.format('DD MMM YYYY') + (end && !start.isSame(end, 'day') ? ' ? ' + end.format('DD MMM YYYY') : '')
    : 'Date to be announced';
  const timeLabel = hasStartTime && start
    ? start.format('h:mm A') + (hasEndTime && end ? ' ? ' + end.format('h:mm A') : '')
    : 'Time to be announced';
  const mode = lookupData.find((item) => String(item.Flag) === '10' && String(item.LookupCode) === String(event.mode))?.LookupValue
    || (String(event.mode) === '2' ? 'Online' : String(event.mode) === '1' ? 'In person' : 'Event');
  const location = String(event.mode) === '2' ? 'Online event' : event.venue || event.meeting_place;

  return (
    <article className="events-card">
      <div className="events-card__media">
        {banner && !imageFailed ? (
          <img src={imageUrl} alt={event.title || 'Event banner'} loading="lazy" onError={() => setImageFailed(true)} />
        ) : (
          <div className="events-card__placeholder" aria-hidden="true"><i className="bi bi-calendar-event"></i><span>ACWADAM EVENTS</span></div>
        )}
        <span className={'events-status events-status--' + status}>{status === 'ongoing' && <span className="events-status__dot" />}{STATUS_LABELS[status]}</span>
      </div>
      <div className="events-card__body">
        <div className="events-card__category"><span>{mode}</span>{String(event.entry_type) === '1' && <span className="events-card__paid">Paid event</span>}</div>
        <h3>{event.title || 'Untitled event'}</h3>
        <dl className="events-card__details">
          <div><dt><i className="bi bi-calendar3" aria-hidden="true"></i><span className="visually-hidden">Date</span></dt><dd>{dateLabel}</dd></div>
          <div><dt><i className="bi bi-clock" aria-hidden="true"></i><span className="visually-hidden">Time</span></dt><dd>{timeLabel}</dd></div>
          {location && <div><dt><i className={'bi ' + (String(event.mode) === '2' ? 'bi-camera-video' : 'bi-geo-alt')} aria-hidden="true"></i><span className="visually-hidden">Location</span></dt><dd>{location}</dd></div>}
        </dl>
        <Link to={'/eventdetails/' + event.id} state={{ register: status === 'upcoming' || status === 'ongoing' }} className="events-card__link" aria-label={'View event: ' + (event.title || 'Untitled event')}>
          View event <i className="bi bi-arrow-right" aria-hidden="true"></i>
        </Link>
      </div>
    </article>
  );
};

export default EventCard;
